import styled from "styled-components";

export const FileUploadContainer = styled.div`
  margin-top: 1rem;
`